import { SOURCE_LABEL, SOURCE_TINT, STATUS_TINT, STATUS_OPTIONS, PAYMENT_METHOD_LABEL } from "./constants";

export function SourcePill({ source, testId }) {
  return (
    <span
      className={`text-[10px] px-2 py-0.5 rounded capitalize ${SOURCE_TINT[source] || SOURCE_TINT.other}`}
      data-testid={testId}
    >
      {SOURCE_LABEL(source)}
    </span>
  );
}

export function PaymentPill({ paymentStatus, paymentMethod, testId }) {
  const status = paymentStatus || "unpaid";
  const isPaid = status === "paid";
  const tint = isPaid
    ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300"
    : "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300";
  return (
    <div data-testid={testId}>
      <span className={`text-xs px-2 py-0.5 rounded capitalize ${tint}`}>{status}</span>
      <div className="text-[10px] text-neutral-500 dark:text-neutral-400 mt-0.5">
        {paymentMethod ? PAYMENT_METHOD_LABEL[paymentMethod] || paymentMethod : "—"}
      </div>
    </div>
  );
}

export function StatusSelect({ status, onChange, testId }) {
  return (
    <select
      value={status}
      onChange={(e) => onChange(e.target.value)}
      className={`text-xs px-2 py-1 rounded border-0 outline-none cursor-pointer ${STATUS_TINT[status] || ""}`}
      data-testid={testId}
    >
      {STATUS_OPTIONS.map((s) => (
        <option key={s.value} value={s.value}>{s.label}</option>
      ))}
    </select>
  );
}
